module.exports = __webpack_public_path__ + "img/claw-marks.384f10d0.svg";